import { Component, h } from 'preact';

const CUSTOMS = {
  'all': 'View all'
};

const OFFICES = {
  'us-president': 'U.S. President',
  'us-house': 'U.S. House',
  'tx-supreme-court': 'Texas Supreme Court',
  'court-criminal-appeals': 'Court of Criminal Appeals',
  'railroad-commission': 'Texas Railroad Commission',
  'sboe': 'State Board of Education',
  'tx-senate': 'Texas Senate',
  'tx-house': 'Texas House'
};

class OfficeChooser extends Component {
  constructor (props) {
    super(props);

    this.state = {
      value: 'all'
    };

    this.handleChange = this.handleChange.bind(this);
  }

  handleChange (e) {
    this.setState({
      value: e.target.value
    }, () => {
      this.props.onChange(this.state.value);
    });
  }

  render () {
    const customOptions = Object.keys(CUSTOMS).map((key) => {
      return <option value={key}>{CUSTOMS[key]}</option>;
    });

    const raceOptions = Object.keys(OFFICES).map((key) => {
      return <option value={key}>{OFFICES[key]}</option>;
    });

    return (
      <div className="office-chooser">
        <p className="office-chooser__label">Filter by race</p>
        <select className="office-chooser__select" value={this.state.value} onChange={this.handleChange}>
          {customOptions}
          <optgroup label="Filter by office">
            {raceOptions}
          </optgroup>
        </select>
      </div>
    );
  }
}

export default OfficeChooser;



// WEBPACK FOOTER //
// ./components/office-chooser.js